module.exports = __webpack_public_path__ + "static/media/1 38 verdt.490aa1f2.mp3";